import React from 'react';
import {HelpTip} from '@taopix/taopix-design-system';
import {HelpTipProps} from '@taopix/taopix-design-system/dist/types/Components/HelpTip/HelpTip';

export type UploadWarningTipProps = Pick<
  HelpTipProps,
  | 'open'
  | 'buttonFunction'
  | 'anchorId'
  | 'anchorOrigin'
  | 'transformOrigin'
  | 'title'
  | 'message'
  | 'arrow'
>;

const UploadWarningTip = ({
  open,
  buttonFunction,
  anchorId,
  anchorOrigin,
  transformOrigin,
  title,
  message,
  arrow,
}: UploadWarningTipProps) => {
  return (
    <HelpTip
      open={open}
      message={message}
      anchorId={anchorId}
      anchorOrigin={anchorOrigin}
      transformOrigin={transformOrigin}
      offset={{x: 0, y: 5}}
      className={'w-[300rem]'}
      buttonFunction={buttonFunction}
      title={title}
      arrow={arrow}
    />
  );
};

export default UploadWarningTip;
